import {
  SET_PANEL_OPEN,
  SET_PANEL_EDIT_STATE,
  SET_UPDATED_COMPANY,
} from '../actionTypes';
import {ISidePanel} from 'constants/interfaces';

const initialState: ISidePanel = {
  open: false,
  panelInfo: undefined,
  withoutOverlay: false,
  editState: 'idle',
  updatedCompany: undefined,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case SET_PANEL_OPEN: {
      const resp = Object.assign(state, action.payload);
      return JSON.parse(JSON.stringify(resp));
    }
    case SET_PANEL_EDIT_STATE: {
      const resp = Object.assign(state, {editState: action.payload});
      return JSON.parse(JSON.stringify(resp));
    }
    case SET_UPDATED_COMPANY: {
      const resp = Object.assign(state, {updatedCompany: action.payload});
      return JSON.parse(JSON.stringify(resp));
    }
    default:
      return state;
  }
}
